import React from 'react';
import { CheckIcon, BookOpenIcon } from 'lucide-react';
const TOMOS = [{
  num: 'TOMO 1',
  title: 'Fundamentos de la Videovigilancia',
  items: ['cómo funciona un sistema de videovigilancia', 'tipos de cámaras y componentes', 'cómo elegir correctamente los equipos', 'cómo evitar errores antes de instalar']
}, {
  num: 'TOMO 2',
  title: 'Instalación Física Paso a Paso',
  items: ['cómo planificar una instalación', 'ubicación, montaje y cableado', 'cómo conectar todo de forma ordenada']
}, {
  num: 'TOMO 3',
  title: 'Configuración y Acceso Remoto',
  items: ['cómo configurar el grabador', 'conexión a internet y acceso remoto', 'cómo ver las cámaras desde el celular']
}, {
  num: 'TOMO 4',
  title: 'Diagnóstico de Fallas y Mantenimiento',
  items: ['cómo detectar y solucionar fallas comunes', 'mantenimiento preventivo', 'cómo evitar problemas recurrentes']
}, {
  num: 'TOMO 5',
  title: 'Cómo Ganar Dinero Instalando Cámaras',
  items: ['cómo presupuestar instalaciones', 'cómo conseguir tus primeros trabajos', 'cómo transformar esto en ingresos']
}];
export function TomoCards() {
  return <section className="bg-[#0d1b2a] py-16 md:py-24 px-4 relative" data-id="element-227">
      {/* Decorative background */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-blue-500/50 to-transparent" data-id="element-228"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-229">
        <div className="text-center mb-16" data-id="element-230">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-900/30 border border-blue-500/30 mb-6 shadow-[0_0_20px_rgba(37,99,235,0.2)]" data-id="element-231">
            <BookOpenIcon className="w-8 h-8 text-blue-400" data-id="element-232" />
          </div>
          <h2 className="text-3xl md:text-5xl font-black text-white uppercase tracking-tight" data-id="element-233">
            ¿QUÉ VAS A ENCONTRAR DENTRO?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-234">
          {TOMOS.map((tomo, idx) => <div key={idx} className="bg-[#0f1d32] rounded-2xl border border-blue-900/40 overflow-hidden hover:border-blue-500/50 hover:shadow-[0_0_30px_rgba(37,99,235,0.15)] hover:-translate-y-1 transition-all duration-300 group flex flex-col" data-id="element-235">
              <div className="bg-gradient-to-r from-blue-700 to-blue-500 text-white py-3 px-5 relative overflow-hidden" data-id="element-236">
                <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMiIgY3k9IjIiIHI9IjIiIGZpbGw9IiNmZmYiIGZpbGwtb3BhY2l0eT0iMC4xIi8+PC9zdmc+')] opacity-30" data-id="element-237"></div>
                <h3 className="text-sm font-black uppercase tracking-widest relative z-10 flex items-center gap-2" data-id="element-238">
                  <span className="bg-white/20 px-2 py-0.5 rounded text-xs" data-id="element-239">
                    {idx + 1}
                  </span>
                  {tomo.num}
                </h3>
              </div>
              <div className="p-6 flex flex-col flex-grow" data-id="element-240">
                <h4 className="text-lg md:text-xl font-bold text-white mb-5 leading-snug group-hover:text-blue-300 transition-colors" data-id="element-241">
                  {tomo.title}
                </h4>
                <div className="bg-[#0a1628] rounded-xl p-4 border border-blue-900/20 flex-grow" data-id="element-242">
                  <ul className="space-y-3" data-id="element-243">
                    {tomo.items.map((item, i) => <li key={i} className="flex items-start" data-id="element-244">
                        <CheckIcon className="w-4 h-4 text-blue-400 mr-2.5 flex-shrink-0 mt-0.5" data-id="element-245" />
                        <span className="text-gray-300 text-sm leading-relaxed" data-id="element-246">
                          {item}
                        </span>
                      </li>)}
                  </ul>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}